import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeAccountCreate,
  detail: routeAccountDetail,
  home: routeAccountsHome,
  root: routeAccountsRoot,
} = createDoctypeRoutes({
  createName: 'new-account',
  createPath: 'new-account',
  detailName: 'accountDetail',
  doctype: DOCTYPES.ACCOUNT,
  homeName: 'accounts',
  path: 'accounts',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/settings/accounting/accounts/AddAccount.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/settings/accounting/accounts/ViewAccount.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/accounting/ViewAccountingSettings.vue'),
  },
})

export { routeAccountCreate, routeAccountDetail, routeAccountsHome, routeAccountsRoot }
